// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MileageSaarathi_summary_icons__mpwZN {
    color: #358696;
    cursor: pointer;
    font-Size: 14px;
    margin-Left: 5px;
}

.MileageSaarathi_page_number_icons_prev__\\+i2x1 {

    border-Radius: 50%;
    width: 30px;
    height: 30px;
    padding: 0;
    border: none !important;
    background-color: #358696;
    color: #3b4553
}

.MileageSaarathi_page_number_icons_prev__\\+i2x1:hover {

    background-color: #358696 !important;
    border-color: #358696;
    color: white;
}

.MileageSaarathi_page_number_icons_prev__\\+i2x1:focus {

    background-color: #358696 !important;
    border-color: #358696;
    color: white;
}

.MileageSaarathi_page_number_icons_next__aMljv {
    border-Radius: 50%;
    width: 30px;
    height: 30px;
    padding: 0;
    border: none !important;
    background-color: white;
    color: #3b4553
}

.MileageSaarathi_page_number_icons_next__aMljv:hover {
    background-color: #358696 !important;
    color: white;
    border-color: #358696 !important;
}

.MileageSaarathi_page_number_icons_next__aMljv:focus {
    background-color: #358696 !important;
    color: white;
    border-color: #358696 !important;
}


.MileageSaarathi_sections_outline__o33T3 {
    background-Color: #f1f2fb;

}

.MileageSaarathi_date_range_selection__q6cvQ {
    color: #358696;
    font-Weight: bold;
}

.MileageSaarathi_download_button__cjDlK {
    color: #358696 !important;
    font-Weight: 200;
}

.MileageSaarathi_summary_vehicle_numbers__ZJHf1 {
    color: #364e69;
    font-Weight: normal;
}

.MileageSaarathi_efficiency_paratext__5Tmhs {
    color: black;
    font-Weight: normal;
}

.MileageSaarathi_efficiency_paranum__yXNXS {
    background-Color: #358696;
    font-Weight: Bold;
    color: #ffffff
}

.MileageSaarathi_graph_circles_energy__Z74Yk {
    height: 12px;
    width: 12px;
    background-Color: #9ac4cc;
    border-radius: 50%;
    display: inline-block;
    margin-Right: 6px;
}

.MileageSaarathi_graph_circles_distance__WtqL2 {
    height: 12px;
    width: 12px;
    background-Color: #ebf3f4;
    border-radius: 50%;
    display: inline-block;
    margin-Right: 6px;
}

.MileageSaarathi_filterbtn__B1Tvn {
    background-color: white;
    color: #358696;
    border-radius: 6px;
    border-color: #358696;
}

.MileageSaarathi_all_vehicles_button__ASDu7 {
    background-Color: #83a4cf;
    border-Color: #1467b3;
}

.MileageSaarathi_table_vehicles_container__b6xgH {
    border-Radius: 12px;
    overflow: hidden;
    border: 1px solid #dee2e6;
}

.MileageSaarathi_table__KP-K7 {
    border-Radius: 12px;
    overflow: hidden;
}

.MileageSaarathi_tableHeaderRow__ksj0o {
    background-color: #358696;
    color: #fff;
}

.MileageSaarathi_tableHeaderRow__ksj0o th {
    cursor: pointer;
}

.MileageSaarathi_tableHeaderCell__muZvK {
    width: 20%;
}

.MileageSaarathi_text-center__XfJzc table-cell {
    background-color: #f5f5f5;
    /* light grey background or your preferred color */
    color: #333;
    /* optional: change text color */
}

.MileageSaarathi_text-center__XfJzc table-cell :hover {
    background-color: #358696;



}


.MileageSaarathi_sortIcon__07DiX {
    color: #fff;
}

.MileageSaarathi_textEnd__Nz0MB {
    text-align: end;
}

.MileageSaarathi_insights_table__qOzxo {

    overflow: hidden;
    border-radius: 12px;
    border: 1px solid #dee2e6;
}

.MileageSaarathi_insights_fixed_col__t2tE9 {
    float: left;
    overflow: hidden;
}

.MileageSaarathi_insights_fixed_col_table__\\+Ft6\\+ {
    border-radius: 12px;
}

.MileageSaarathi_insights_fixed_col_tableheader__9NNdL {
    background-color: #358696;
    color: #fff;
    height: 60px;
}

/* .insights_scroll_sec {
    margin-left: auto;
    position: relative;
    border-left: 1px solid #dee2e6;
} */

.MileageSaarathi_insights_fixed_col_tabledata__V7A61 {
    background-color: #fff;
}

/* Arrows Styling */
.MileageSaarathi_insights_scroll_arrow__xKm9B {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    background: rgba(255, 255, 255, 0.8);
    border: 1px solid #dee2e6;
    border-radius: 50%;
    font-size: 16px;
    color: #555;
    padding: 5px 8px;
    outline: none;
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.MileageSaarathi_insights_scroll_arrow__xKm9B:hover {
    background: rgba(131, 164, 207, 0.2);
}

/* Left Arrow */
.MileageSaarathi_left__feQbK {
    left: 5px;
}

/* Right Arrow */
.MileageSaarathi_right__HUXM1 {
    right: 5px;
}

.MileageSaarathi_insights_scroll__6YrIx {
    overflow-x: scroll;
    width: 100%;
    scrollbar-width: none;
    /* For Firefox */
    -ms-overflow-style: none;
    /* For IE and Edge */
}

/* Hide scrollbar for Chrome, Safari and Opera */
/* .insights_scroll::-webkit-scrollbar {
    display: none;
} */

.MileageSaarathi_insights_scroll_table__VdkxT {
    border-radius: 0 12px 12px 0;
    /* min-width: 1000px; */
}

.MileageSaarathi_insights_scroll_tablerow__uPYYC {
    height: 60px;
    /* same height for both header rows */
    vertical-align: middle;
    text-align: center;
    background-Color: #358696;
    color: #fff;
}

.MileageSaarathi_insights_scroll_tabledata__6oMnF {
    background-color: #fff;
}

.MileageSaarathi_best_vehicle__GIkyD {
    border-Radius: 12px;
    overflow: hidden;
    border: 1px solid #dee2e6;
}

.MileageSaarathi_best_vehicle_table__aLPNG {
    border-Radius: 12px;
    /* overflow: hidden; */
    border: 1px solid #dee2e6;
}

.MileageSaarathi_best_vehicle_table__aLPNG {
    border-Radius: 12px;
}

.MileageSaarathi_best_vehicle_tablerow__EniZS {
    background-Color: #358696;
    color: #fff;
}

.MileageSaarathi_best_vehicle_tablerowstyle__vS3QX {
    background-Color: #fff;
}

.MileageSaarathi_vehicle_analysis__rk8T\\+ {
    border-Radius: 12px;
    overflow: hidden;
    border: 1px solid #dee2e6;
}

.MileageSaarathi_vehicle_analysis_table__q\\+nxI {
    border-Radius: 12px;
}

.MileageSaarathi_vehicle_analysis_tablerow__OxfeO {
    background-Color: #358696;
    color: #fff;
}

.MileageSaarathi_vehicle_icon__dKcRW {
    width: 24px;
    height: 24px;
    background-Color: #358696;
}

.MileageSaarathi_incidents_tab__Lp0gW {
    border-Radius: 12px;
    overflow: hidden;
    border: 1px solid #dee2e6;
}

.MileageSaarathi_incidents_tab_tablerow__e6Nzr {
    background-Color: #358696;
    color: #fff;
}

.MileageSaarathi_incidents_tab_tablerowstyle__9wjpc {
    background-Color: #fff;
}

.MileageSaarathi_incidents_tab_details__jb7ef {
    cursor: pointer;
    padding: 2px 6px;
    margin-Bottom: 4px;
    border: 1px solid #358696;
    border-Radius: 4px;
    color: #358696;
    font-Size: 12px;
    display: inline-block;
    background-Color: #fff;
    transition: background-color 0.2s ease;
}

.MileageSaarathi_incidents_tab_location__9eZyj {
    display: none;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    padding: 2px 6px;
    border: 1px solid #358696;
    border-Radius: 4px;
    color: #358696;
    font-Size: 12px;
    display: inline-block;
    background-Color: #fff;
}

.MileageSaarathi_driver_behaviour__jDc9- {
    border-Radius: 12px;
    overflow: hidden;
    border: 1px solid #dee2e6;

}

.MileageSaarathi_driver_behaviour_tablerow__XoW1B {
    background-Color: #358696;
    color: #fff;
}

.MileageSaarathi_driver_behaviour_tablerowstyle__d\\+3qX {
    background-Color: #fff;
}

.MileageSaarathi_driver_behaviour_details__P-9NN {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-Color: rgba(0, 0, 0, 0.5);
    backdrop-Filter: blur(4px);
    z-Index: 9999;
    display: flex;
    justify-Content: center;
    align-Items: center;
    transition: all 0.3s ease;
}

.MileageSaarathi_service_summary__QUmpl {
    border-Radius: 12px;
    overflow: hidden;
}

.MileageSaarathi_service_summary_tablerow__WVxQm {
    background-Color: #358696;
    color: #fff;
    position: sticky;
    top: 0;
}

.MileageSaarathi_service_summary_tablerowstyle__y\\+72C {
    background-Color: #fff;
}

.MileageSaarathi_service_summary_vehicle_icon__gLyYx {
    width: 28px;
    height: 28px;
    background-Color: #358696;
    font-Size: 14px;
}

.MileageSaarathi_filter_dropdown__kZTKA {
    border-radius: 5px;
    border: none;
    box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);
    font-size: 13px;
    padding-top: 7px;
    padding-bottom: 7px;
    cursor: pointer;
    background-color: white;

}

.MileageSaarathi_filter_dropdown__kZTKA:active {
    border-radius: 5px;
    border: none;
    box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);
    font-size: 13px;
    padding-top: 7px;
    padding-bottom: 7px;
    cursor: pointer;
    background-color: white;

}

.MileageSaarathi_toggle_button__a1h-h {
    background-color: #ccc;
    cursor: pointer;


}

.MileageSaarathi_toggle_button__a1h-h:checked {
    background-color: #358696 !important;

}



.MileageSaarathi_toggle_button__a1h-h:focus {
    outline: none;
    box-shadow: none;
    background-image: none;
}

.MileageSaarathi_ms_button__0olJt {
    background-color: transparent;
    /* default */
    color: #364e69;
    border: none;
    font-size: 13px;
    transition: background-color 0.3s ease;
    text-decoration: underline;
}


/* On hover */
.MileageSaarathi_ms_button__0olJt:hover {
    background-color: #358696 !important;
    border-radius: 5px;
    color: white;
}

/* On focus */
.MileageSaarathi_ms_button__0olJt:focus {
    background-color: transparent;
    outline: none;
}

.MileageSaarathi_service_modal_icon__yZdwL {
    color: #358696 !important;
    background-color: #e0ebf9 !important;
}

.MileageSaarathi_analysis_header__LnDFb {
    color: #364e69;
    font-Weight: bold;
    font-size: 20px;
}

.MileageSaarathi_selected_header__HEo63 {
    color: #364e69;
    font-Weight: bold;
    font-size: 15px;
}

.MileageSaarathi_custom-close-btn__bQsPE {
    color: #6c757d;
    background-color: transparent;
    border: none;
    padding: 0;
    outline: none;
    cursor: pointer;
}

.MileageSaarathi_custom-close-btn__bQsPE:hover,
.MileageSaarathi_custom-close-btn__bQsPE:focus,
.MileageSaarathi_custom-close-btn__bQsPE:active {
    color: #6c757d;
    background-color: transparent !important;
    /* this kills any Bootstrap override */
    box-shadow: none;
}


.MileageSaarathi_insights_grid_wrapper__1nXC1 {
    display: grid;
    grid-template-columns: 500px 1fr;
    overflow: hidden;
}

.MileageSaarathi_insights_fixed_col_wrapper__dOPl6 {
    overflow-y: auto;
    border-radius: 12px;
}

.MileageSaarathi_insights_scroll_sec__5OXvu {
    overflow-x: auto;
    position: relative;
    border-radius: 12px;
}

.MileageSaarathi_insights_scroll__6YrIx {
    overflow-x: auto;
    white-space: nowrap;
}

.MileageSaarathi_insights_scroll_arrow__xKm9B {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    background: #ffffff;
    border: 1px solid #ccc;
    padding: 4px 8px;
    cursor: pointer;
}

.MileageSaarathi_insights_scroll_arrow__xKm9B.MileageSaarathi_left__feQbK {
    left: 0;
}

.MileageSaarathi_insights_scroll_arrow__xKm9B.MileageSaarathi_right__HUXM1 {
    right: 0;
}

.MileageSaarathi_datePickerWidth__Jq8si {
    width: 250px;
}

.MileageSaarathi_suggestedActionWidth__-Ztuu {
    width: 400px;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/MileageSaarathiAce/MileageSaarathiTab_ace/MileageSaarathi.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,oCAAoC;IACpC,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;IAEI,oCAAoC;IACpC,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,uBAAuB;IACvB;AACJ;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,gCAAgC;AACpC;;;AAGA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,kDAAkD;IAClD,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;;;;AAI7B;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;AAEA;;;;GAIG;;AAEH;IACI,sBAAsB;AAC1B;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,oCAAoC;IACpC,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC;;AAEA,eAAe;AACf;IACI,SAAS;AACb;;AAEA,gBAAgB;AAChB;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA,gDAAgD;AAChD;;GAEG;;AAEH;IACI,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,qCAAqC;IACrC,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,UAAU;IACV,oCAAoC;IACpC,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;;AAE7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,0BAA0B;IAC1B,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,MAAM;AACV;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,6CAA6C;IAC7C,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,uBAAuB;;AAE3B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,6CAA6C;IAC7C,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,uBAAuB;;AAE3B;;AAEA;IACI,sBAAsB;IACtB,eAAe;;;AAGnB;;AAEA;IACI,oCAAoC;;AAExC;;;;AAIA;IACI,aAAa;IACb,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,0BAA0B;AAC9B;;;AAGA,aAAa;AACb;IACI,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;AAChB;;AAEA,aAAa;AACb;IACI,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,YAAY;IACZ,UAAU;IACV,aAAa;IACb,eAAe;AACnB;;AAEA;;;IAGI,cAAc;IACd,wCAAwC;IACxC,sCAAsC;IACtC,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".summary_icons {\n    color: #358696;\n    cursor: pointer;\n    font-Size: 14px;\n    margin-Left: 5px;\n}\n\n.page_number_icons_prev {\n\n    border-Radius: 50%;\n    width: 30px;\n    height: 30px;\n    padding: 0;\n    border: none !important;\n    background-color: #358696;\n    color: #3b4553\n}\n\n.page_number_icons_prev:hover {\n\n    background-color: #358696 !important;\n    border-color: #358696;\n    color: white;\n}\n\n.page_number_icons_prev:focus {\n\n    background-color: #358696 !important;\n    border-color: #358696;\n    color: white;\n}\n\n.page_number_icons_next {\n    border-Radius: 50%;\n    width: 30px;\n    height: 30px;\n    padding: 0;\n    border: none !important;\n    background-color: white;\n    color: #3b4553\n}\n\n.page_number_icons_next:hover {\n    background-color: #358696 !important;\n    color: white;\n    border-color: #358696 !important;\n}\n\n.page_number_icons_next:focus {\n    background-color: #358696 !important;\n    color: white;\n    border-color: #358696 !important;\n}\n\n\n.sections_outline {\n    background-Color: #f1f2fb;\n\n}\n\n.date_range_selection {\n    color: #358696;\n    font-Weight: bold;\n}\n\n.download_button {\n    color: #358696 !important;\n    font-Weight: 200;\n}\n\n.summary_vehicle_numbers {\n    color: #364e69;\n    font-Weight: normal;\n}\n\n.efficiency_paratext {\n    color: black;\n    font-Weight: normal;\n}\n\n.efficiency_paranum {\n    background-Color: #358696;\n    font-Weight: Bold;\n    color: #ffffff\n}\n\n.graph_circles_energy {\n    height: 12px;\n    width: 12px;\n    background-Color: #9ac4cc;\n    border-radius: 50%;\n    display: inline-block;\n    margin-Right: 6px;\n}\n\n.graph_circles_distance {\n    height: 12px;\n    width: 12px;\n    background-Color: #ebf3f4;\n    border-radius: 50%;\n    display: inline-block;\n    margin-Right: 6px;\n}\n\n.filterbtn {\n    background-color: white;\n    color: #358696;\n    border-radius: 6px;\n    border-color: #358696;\n}\n\n.all_vehicles_button {\n    background-Color: #83a4cf;\n    border-Color: #1467b3;\n}\n\n.table_vehicles_container {\n    border-Radius: 12px;\n    overflow: hidden;\n    border: 1px solid #dee2e6;\n}\n\n.table {\n    border-Radius: 12px;\n    overflow: hidden;\n}\n\n.tableHeaderRow {\n    background-color: #358696;\n    color: #fff;\n}\n\n.tableHeaderRow th {\n    cursor: pointer;\n}\n\n.tableHeaderCell {\n    width: 20%;\n}\n\n.text-center table-cell {\n    background-color: #f5f5f5;\n    /* light grey background or your preferred color */\n    color: #333;\n    /* optional: change text color */\n}\n\n.text-center table-cell :hover {\n    background-color: #358696;\n\n\n\n}\n\n\n.sortIcon {\n    color: #fff;\n}\n\n.textEnd {\n    text-align: end;\n}\n\n.insights_table {\n\n    overflow: hidden;\n    border-radius: 12px;\n    border: 1px solid #dee2e6;\n}\n\n.insights_fixed_col {\n    float: left;\n    overflow: hidden;\n}\n\n.insights_fixed_col_table {\n    border-radius: 12px;\n}\n\n.insights_fixed_col_tableheader {\n    background-color: #358696;\n    color: #fff;\n    height: 60px;\n}\n\n/* .insights_scroll_sec {\n    margin-left: auto;\n    position: relative;\n    border-left: 1px solid #dee2e6;\n} */\n\n.insights_fixed_col_tabledata {\n    background-color: #fff;\n}\n\n/* Arrows Styling */\n.insights_scroll_arrow {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 10;\n    background: rgba(255, 255, 255, 0.8);\n    border: 1px solid #dee2e6;\n    border-radius: 50%;\n    font-size: 16px;\n    color: #555;\n    padding: 5px 8px;\n    outline: none;\n    cursor: pointer;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.insights_scroll_arrow:hover {\n    background: rgba(131, 164, 207, 0.2);\n}\n\n/* Left Arrow */\n.left {\n    left: 5px;\n}\n\n/* Right Arrow */\n.right {\n    right: 5px;\n}\n\n.insights_scroll {\n    overflow-x: scroll;\n    width: 100%;\n    scrollbar-width: none;\n    /* For Firefox */\n    -ms-overflow-style: none;\n    /* For IE and Edge */\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n/* .insights_scroll::-webkit-scrollbar {\n    display: none;\n} */\n\n.insights_scroll_table {\n    border-radius: 0 12px 12px 0;\n    /* min-width: 1000px; */\n}\n\n.insights_scroll_tablerow {\n    height: 60px;\n    /* same height for both header rows */\n    vertical-align: middle;\n    text-align: center;\n    background-Color: #358696;\n    color: #fff;\n}\n\n.insights_scroll_tabledata {\n    background-color: #fff;\n}\n\n.best_vehicle {\n    border-Radius: 12px;\n    overflow: hidden;\n    border: 1px solid #dee2e6;\n}\n\n.best_vehicle_table {\n    border-Radius: 12px;\n    /* overflow: hidden; */\n    border: 1px solid #dee2e6;\n}\n\n.best_vehicle_table {\n    border-Radius: 12px;\n}\n\n.best_vehicle_tablerow {\n    background-Color: #358696;\n    color: #fff;\n}\n\n.best_vehicle_tablerowstyle {\n    background-Color: #fff;\n}\n\n.vehicle_analysis {\n    border-Radius: 12px;\n    overflow: hidden;\n    border: 1px solid #dee2e6;\n}\n\n.vehicle_analysis_table {\n    border-Radius: 12px;\n}\n\n.vehicle_analysis_tablerow {\n    background-Color: #358696;\n    color: #fff;\n}\n\n.vehicle_icon {\n    width: 24px;\n    height: 24px;\n    background-Color: #358696;\n}\n\n.incidents_tab {\n    border-Radius: 12px;\n    overflow: hidden;\n    border: 1px solid #dee2e6;\n}\n\n.incidents_tab_tablerow {\n    background-Color: #358696;\n    color: #fff;\n}\n\n.incidents_tab_tablerowstyle {\n    background-Color: #fff;\n}\n\n.incidents_tab_details {\n    cursor: pointer;\n    padding: 2px 6px;\n    margin-Bottom: 4px;\n    border: 1px solid #358696;\n    border-Radius: 4px;\n    color: #358696;\n    font-Size: 12px;\n    display: inline-block;\n    background-Color: #fff;\n    transition: background-color 0.2s ease;\n}\n\n.incidents_tab_location {\n    display: none;\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out;\n    padding: 2px 6px;\n    border: 1px solid #358696;\n    border-Radius: 4px;\n    color: #358696;\n    font-Size: 12px;\n    display: inline-block;\n    background-Color: #fff;\n}\n\n.driver_behaviour {\n    border-Radius: 12px;\n    overflow: hidden;\n    border: 1px solid #dee2e6;\n\n}\n\n.driver_behaviour_tablerow {\n    background-Color: #358696;\n    color: #fff;\n}\n\n.driver_behaviour_tablerowstyle {\n    background-Color: #fff;\n}\n\n.driver_behaviour_details {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-Color: rgba(0, 0, 0, 0.5);\n    backdrop-Filter: blur(4px);\n    z-Index: 9999;\n    display: flex;\n    justify-Content: center;\n    align-Items: center;\n    transition: all 0.3s ease;\n}\n\n.service_summary {\n    border-Radius: 12px;\n    overflow: hidden;\n}\n\n.service_summary_tablerow {\n    background-Color: #358696;\n    color: #fff;\n    position: sticky;\n    top: 0;\n}\n\n.service_summary_tablerowstyle {\n    background-Color: #fff;\n}\n\n.service_summary_vehicle_icon {\n    width: 28px;\n    height: 28px;\n    background-Color: #358696;\n    font-Size: 14px;\n}\n\n.filter_dropdown {\n    border-radius: 5px;\n    border: none;\n    box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);\n    font-size: 13px;\n    padding-top: 7px;\n    padding-bottom: 7px;\n    cursor: pointer;\n    background-color: white;\n\n}\n\n.filter_dropdown:active {\n    border-radius: 5px;\n    border: none;\n    box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);\n    font-size: 13px;\n    padding-top: 7px;\n    padding-bottom: 7px;\n    cursor: pointer;\n    background-color: white;\n\n}\n\n.toggle_button {\n    background-color: #ccc;\n    cursor: pointer;\n\n\n}\n\n.toggle_button:checked {\n    background-color: #358696 !important;\n\n}\n\n\n\n.toggle_button:focus {\n    outline: none;\n    box-shadow: none;\n    background-image: none;\n}\n\n.ms_button {\n    background-color: transparent;\n    /* default */\n    color: #364e69;\n    border: none;\n    font-size: 13px;\n    transition: background-color 0.3s ease;\n    text-decoration: underline;\n}\n\n\n/* On hover */\n.ms_button:hover {\n    background-color: #358696 !important;\n    border-radius: 5px;\n    color: white;\n}\n\n/* On focus */\n.ms_button:focus {\n    background-color: transparent;\n    outline: none;\n}\n\n.service_modal_icon {\n    color: #358696 !important;\n    background-color: #e0ebf9 !important;\n}\n\n.analysis_header {\n    color: #364e69;\n    font-Weight: bold;\n    font-size: 20px;\n}\n\n.selected_header {\n    color: #364e69;\n    font-Weight: bold;\n    font-size: 15px;\n}\n\n.custom-close-btn {\n    color: #6c757d;\n    background-color: transparent;\n    border: none;\n    padding: 0;\n    outline: none;\n    cursor: pointer;\n}\n\n.custom-close-btn:hover,\n.custom-close-btn:focus,\n.custom-close-btn:active {\n    color: #6c757d;\n    background-color: transparent !important;\n    /* this kills any Bootstrap override */\n    box-shadow: none;\n}\n\n\n.insights_grid_wrapper {\n    display: grid;\n    grid-template-columns: 500px 1fr;\n    overflow: hidden;\n}\n\n.insights_fixed_col_wrapper {\n    overflow-y: auto;\n    border-radius: 12px;\n}\n\n.insights_scroll_sec {\n    overflow-x: auto;\n    position: relative;\n    border-radius: 12px;\n}\n\n.insights_scroll {\n    overflow-x: auto;\n    white-space: nowrap;\n}\n\n.insights_scroll_arrow {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 10;\n    background: #ffffff;\n    border: 1px solid #ccc;\n    padding: 4px 8px;\n    cursor: pointer;\n}\n\n.insights_scroll_arrow.left {\n    left: 0;\n}\n\n.insights_scroll_arrow.right {\n    right: 0;\n}\n\n.datePickerWidth {\n    width: 250px;\n}\n\n.suggestedActionWidth {\n    width: 400px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"summary_icons": `MileageSaarathi_summary_icons__mpwZN`,
	"page_number_icons_prev": `MileageSaarathi_page_number_icons_prev__+i2x1`,
	"page_number_icons_next": `MileageSaarathi_page_number_icons_next__aMljv`,
	"sections_outline": `MileageSaarathi_sections_outline__o33T3`,
	"date_range_selection": `MileageSaarathi_date_range_selection__q6cvQ`,
	"download_button": `MileageSaarathi_download_button__cjDlK`,
	"summary_vehicle_numbers": `MileageSaarathi_summary_vehicle_numbers__ZJHf1`,
	"efficiency_paratext": `MileageSaarathi_efficiency_paratext__5Tmhs`,
	"efficiency_paranum": `MileageSaarathi_efficiency_paranum__yXNXS`,
	"graph_circles_energy": `MileageSaarathi_graph_circles_energy__Z74Yk`,
	"graph_circles_distance": `MileageSaarathi_graph_circles_distance__WtqL2`,
	"filterbtn": `MileageSaarathi_filterbtn__B1Tvn`,
	"all_vehicles_button": `MileageSaarathi_all_vehicles_button__ASDu7`,
	"table_vehicles_container": `MileageSaarathi_table_vehicles_container__b6xgH`,
	"table": `MileageSaarathi_table__KP-K7`,
	"tableHeaderRow": `MileageSaarathi_tableHeaderRow__ksj0o`,
	"tableHeaderCell": `MileageSaarathi_tableHeaderCell__muZvK`,
	"text-center": `MileageSaarathi_text-center__XfJzc`,
	"sortIcon": `MileageSaarathi_sortIcon__07DiX`,
	"textEnd": `MileageSaarathi_textEnd__Nz0MB`,
	"insights_table": `MileageSaarathi_insights_table__qOzxo`,
	"insights_fixed_col": `MileageSaarathi_insights_fixed_col__t2tE9`,
	"insights_fixed_col_table": `MileageSaarathi_insights_fixed_col_table__+Ft6+`,
	"insights_fixed_col_tableheader": `MileageSaarathi_insights_fixed_col_tableheader__9NNdL`,
	"insights_fixed_col_tabledata": `MileageSaarathi_insights_fixed_col_tabledata__V7A61`,
	"insights_scroll_arrow": `MileageSaarathi_insights_scroll_arrow__xKm9B`,
	"left": `MileageSaarathi_left__feQbK`,
	"right": `MileageSaarathi_right__HUXM1`,
	"insights_scroll": `MileageSaarathi_insights_scroll__6YrIx`,
	"insights_scroll_table": `MileageSaarathi_insights_scroll_table__VdkxT`,
	"insights_scroll_tablerow": `MileageSaarathi_insights_scroll_tablerow__uPYYC`,
	"insights_scroll_tabledata": `MileageSaarathi_insights_scroll_tabledata__6oMnF`,
	"best_vehicle": `MileageSaarathi_best_vehicle__GIkyD`,
	"best_vehicle_table": `MileageSaarathi_best_vehicle_table__aLPNG`,
	"best_vehicle_tablerow": `MileageSaarathi_best_vehicle_tablerow__EniZS`,
	"best_vehicle_tablerowstyle": `MileageSaarathi_best_vehicle_tablerowstyle__vS3QX`,
	"vehicle_analysis": `MileageSaarathi_vehicle_analysis__rk8T+`,
	"vehicle_analysis_table": `MileageSaarathi_vehicle_analysis_table__q+nxI`,
	"vehicle_analysis_tablerow": `MileageSaarathi_vehicle_analysis_tablerow__OxfeO`,
	"vehicle_icon": `MileageSaarathi_vehicle_icon__dKcRW`,
	"incidents_tab": `MileageSaarathi_incidents_tab__Lp0gW`,
	"incidents_tab_tablerow": `MileageSaarathi_incidents_tab_tablerow__e6Nzr`,
	"incidents_tab_tablerowstyle": `MileageSaarathi_incidents_tab_tablerowstyle__9wjpc`,
	"incidents_tab_details": `MileageSaarathi_incidents_tab_details__jb7ef`,
	"incidents_tab_location": `MileageSaarathi_incidents_tab_location__9eZyj`,
	"driver_behaviour": `MileageSaarathi_driver_behaviour__jDc9-`,
	"driver_behaviour_tablerow": `MileageSaarathi_driver_behaviour_tablerow__XoW1B`,
	"driver_behaviour_tablerowstyle": `MileageSaarathi_driver_behaviour_tablerowstyle__d+3qX`,
	"driver_behaviour_details": `MileageSaarathi_driver_behaviour_details__P-9NN`,
	"service_summary": `MileageSaarathi_service_summary__QUmpl`,
	"service_summary_tablerow": `MileageSaarathi_service_summary_tablerow__WVxQm`,
	"service_summary_tablerowstyle": `MileageSaarathi_service_summary_tablerowstyle__y+72C`,
	"service_summary_vehicle_icon": `MileageSaarathi_service_summary_vehicle_icon__gLyYx`,
	"filter_dropdown": `MileageSaarathi_filter_dropdown__kZTKA`,
	"toggle_button": `MileageSaarathi_toggle_button__a1h-h`,
	"ms_button": `MileageSaarathi_ms_button__0olJt`,
	"service_modal_icon": `MileageSaarathi_service_modal_icon__yZdwL`,
	"analysis_header": `MileageSaarathi_analysis_header__LnDFb`,
	"selected_header": `MileageSaarathi_selected_header__HEo63`,
	"custom-close-btn": `MileageSaarathi_custom-close-btn__bQsPE`,
	"insights_grid_wrapper": `MileageSaarathi_insights_grid_wrapper__1nXC1`,
	"insights_fixed_col_wrapper": `MileageSaarathi_insights_fixed_col_wrapper__dOPl6`,
	"insights_scroll_sec": `MileageSaarathi_insights_scroll_sec__5OXvu`,
	"datePickerWidth": `MileageSaarathi_datePickerWidth__Jq8si`,
	"suggestedActionWidth": `MileageSaarathi_suggestedActionWidth__-Ztuu`
};
export default ___CSS_LOADER_EXPORT___;
